import "react-id-swiper/src/styles/css/swiper.css";

import { Typography, WithStyles, withStyles } from "@material-ui/core";
import { capitalize, chain } from "lodash";
import * as moment from "moment";
import * as React from "react";

import { Quotation } from "../../types/Quotation";
import HomeSwiper from "../HomeSwiper/HomeSwiper";
import StatisticElement from "./StatisticElement";
import { styles } from "./Statistics.style";

interface StatisticsProps {
    quotations?: Quotation[];
}
class Statistics extends React.Component<StatisticsProps & WithStyles<typeof styles>> {
    public render() {
        const { classes, quotations } = this.props;

        return (
            <div className={classes.container}>
                <Typography variant="display1">Mes statistiques</Typography>
                <HomeSwiper slides={4}>{this.renderStatisticElements(quotations)}</HomeSwiper>
            </div>
        );
    }

    private renderStatisticElements(quotations) {
        return chain(quotations)
            .countBy((q) => capitalize(moment(q.creationDate).format("MMMM")))
            .map((count: number, month: string) => (
                <div key={month}>
                    <StatisticElement month={month} count={count} />
                </div>
            ))
            .value();
    }
}

export default withStyles(styles)(Statistics);



// WEBPACK FOOTER //
// ./src/components/Statistics/Statistics.tsx